import { required, minLength, numeric, requiredIf } from 'vuelidate/lib/validators';

export const validLabelCharacters = (str = '') => !!str && !str.includes(' ');

// Custom validator for positive natural numbers (1, 2, 3, ...)
export const positiveNaturalNumber = (value) => {
  if (!value) return true; // Let required handle empty values
  const num = Number(value);
  return Number.isInteger(num) && num >= 1;
};

export default {
  title: {
    required,
    minLength: minLength(2),
    validLabelCharacters,
  },
  description: {},
  dataList: {
    $each: {
      trigger_before: { 
        required: requiredIf(function() {
          return this.forAutomation;
        }),
        positiveNaturalNumber
      },
      macro_id: { 
        required: requiredIf(function() {
          return this.forAutomation;
        }), 
        numeric 
      },
      time_unit: { 
        required: requiredIf(function() {
          return this.forAutomation;
        })
      },
      is_before: { 
        required: requiredIf(function() {
          return this.forAutomation;
        })
      }
    }
  },
  contactAutomationData: {
    inbox_id: { 
      required: requiredIf(function() {
        return this.forContactAutomation;
      }), 
      numeric 
    },
    label_id: { 
      required: requiredIf(function() {
        return this.forContactAutomation;
      })
    }
  },
  color: {
    required,
  },
  showOnSidebar: {},
};
